import { createPermissionChecker, prepareIotRoutes } from './helper';

export default prepareIotRoutes([
    {
        name: 'iot.residents-queue.index',
        path: '/iot/residents-queue',
        components: {
            default: () => import(/* webpackChunkName: "iot" */ '@/views/iot/residents_queue/Index'),
            //ui_v3: () => import(/* webpackChunkName: "iot" */ '@/views/iot/residents_queue/v3/Index'),
        },
        meta: {
            actions: true,
            breadcrumbName: 'resident queue',
            title: 'resident queue',
            flowStartsWith: 'iot.residents-queue.index',
            permissionChecker: createPermissionChecker('RESIDENT_READ_RESIDENT_EVENT_QUEUE'),
        },
    },
    {
        name: 'iot.residents-queue-configuration',
        path: '/iot/residents-queue/configuration',
        component: () => import(/* webpackChunkName: "iot" */ '@/views/iot/residents_queue/ResidentQueueSettings.vue'),
        meta: {
            actions: true,
            breadcrumbName: 'displaying options',
            title: 'displaying options',
            flowStartsWith: 'iot.residents-queue.index',
            permissionChecker: createPermissionChecker('RESIDENT_READ_RESIDENT_EVENT_QUEUE'),
        },
    },
]);
